//
export const AUTH_INVALIDATE = 'auth/AUTH_INVALIDATE';

//login
export const LOGIN_REQUEST = 'auth/LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'auth/LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'auth/LOGIN_FAILURE';

export const ADMIN_LOGIN_REQUEST = 'auth/ADMIN_LOGIN_REQUEST';
export const ADMIN_LOGIN_SUCCESS = 'auth/ADMIN_LOGIN_SUCCESS';

//logout
export const LOGOUT_REQUEST = 'auth/LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'auth/LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'auth/LOGOUT_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/auth/auth.actionTypes.js